<script>
import TwTabsNavigation from '@/components/generic/tabs/tw-tabs-navigation.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import FundraiserAboutTab from '@/components/fundraisers/public/fundraiser-about-tab.vue'
import FundraiserUpdatesViewPublic from '@/components/fundraisers/fundraiser-updates-view-public.vue'
import FundraiserTeamAboutTab from './fundraiser-team-about-tab.vue'

export default {
  name: 'FundraiserTeamAboutTabs',
  components: { FundraiserTeamAboutTab, FundraiserUpdatesViewPublic, FundraiserAboutTab, TwTransitionContainer, TwTabsNavigation },
  props: {
    fundraiser: {
      type: Object,
      required: true
    },
    team: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ActiveTab: null
    }
  },
  computed: {
    tabs(){
      const tabs = []
      tabs.push({ name: 'About', slug: 'about' })
      tabs.push({ name: 'Updates', slug: 'updates', badge: this.fundraiser.cached.fundraiser_updates_count ?? null })
      return tabs
    }
  },
  beforeMount() {
    if(this.$route.params.section) {
      this.ActiveTab = this.$route.params.section
    }
    else {
      this.ActiveTab = 'about'
    }
  }
}
</script>

<template>
  <div>
    <tw-tabs-navigation v-model="ActiveTab" :tabs="tabs" id-field="slug" />
    <tw-transition-container class="mt-4 pt-2">
      <div v-if="ActiveTab === 'about'">
        <fundraiser-team-about-tab :team="team" :fundraiser="fundraiser" />
      </div>
      <div v-else-if="ActiveTab === 'updates'">
        <fundraiser-updates-view-public :updatable-type="fundraiser.object_type" :updatable-id="fundraiser.id" />
      </div>
    </tw-transition-container>
  </div>
</template>

<style scoped>

</style>
